<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-select v-model="editInfo.languageCode" @change="langChange">
          <el-option
            v-for="item in languages"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="(showEdit = true), (opType = 'insert')"
          >新增组件
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="kingKongList">
      <el-table-column label="名称" prop="name" />
      <el-table-column label="类型ID" prop="categoryId" >
        <template slot-scope="scope">
          <span>{{scope.row.categoryId | formatData(that)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="日间 icon" prop="iconDay" />
      <el-table-column label="夜间 icon" prop="iconNight" />
      <el-table-column label="热门">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isHot"
            active-color="#13ce66"
            inactive-color="#ff4949"
            disabled
          />
        </template>
      </el-table-column>
      <el-table-column label="最新">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isNew"
            active-color="#13ce66"
            inactive-color="#ff4949"
            disabled
          />
        </template>
      </el-table-column>
      <el-table-column label="显示">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.display"
            active-color="#13ce66"
            inactive-color="#ff4949"
            disabled
          />
        </template>
      </el-table-column>
      <el-table-column label="删除">
        <template slot-scope="scope">
          <el-button type="text" @click="deleteRecord(scope.row.id)"
            >删除</el-button
          >
          <el-button type="text" @click="updateOpen(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="编辑组件" :visible.sync="showEdit" @close="closeEdit()">
      <el-form :model="editInfo" ref="kingKongForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editInfo.name" />
        </el-form-item>
        <el-form-item label="显示隐藏" prop="display">
          <el-switch
            v-model="editInfo.display"
            active-color="#13ce66"
            inactive-color="#ff4949"
          />
        </el-form-item>
        <el-form-item label="是否热门" prop="isHot">
          <el-switch
            v-model="editInfo.isHot"
            active-color="#13ce66"
            inactive-color="#ff4949"
          />
        </el-form-item>
        <el-form-item label="是否最新" prop="isNew">
          <el-switch
            v-model="editInfo.isNew"
            active-color="#13ce66"
            inactive-color="#ff4949"
          />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="editInfo.categoryId" placeholder="请选择">
            <el-option label="不选类型" value="0"></el-option>
            <el-option v-for="(item, index) in categorys" :key="index" :label="item.categoryName" :value="item.id" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="链接"
          prop="link"
          :rules="[
            { required: true, message: '链接不能为空', trigger: 'blur' },
          ]"
        >
          <el-input v-model="editInfo.link" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="editInfo.sortNum" />
        </el-form-item>
        <el-form-item label="日间ICON" prop="iconDay">
          <upload
            v-model="editInfo.iconDay"
            :data="{ language: 1, platform: 1 }"
          />
        </el-form-item>
        <el-form-item label="夜间ICON" prop="iconNight">
          <upload
            v-model="editInfo.iconNight"
            :data="{ language: 1, platform: 1 }"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="closeEdit()">取消</el-button>
          <el-button type="primary" @click="submitRecord()">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import api from "./api";
import "../store";
import { mapActions, mapState } from "vuex";
import upload from "../../../components/upload";
import LANGUAGE from "common/languages";

export default {
  name: "kingKong",
  data() {
    return {
      showEdit: false,
      opType: "",
      languages: Object.keys(LANGUAGE).map(item => {
            return {
                value: Number(item),
                label: LANGUAGE[item]
            };
        }),
      editInfo: {
        languageCode: 1,
        createTime: "",
        deleted: false,
        display: false,
        iconDay: "",
        iconNight: "",
        id: 0,
        isHot: false,
        isNew: false,
        link: "",
        name: "",
        sortNum: "",
        categoryId: "",
        updateTime: "",
      },
      categorys: [],
        that:this
    };
  },
  computed: {
    ...mapState("PortalManage", ["kingKongList", "areaType"]),
  },
    components: {upload},
    filters: {
        formatData(val, that) {
            for (let i = 0; i < that._data.categorys.length; i++) {
                if (that._data.categorys[i].id == val) {
                    return that._data.categorys[i].categoryName;
                }
            }
            return "";
        }
    },
  methods: {
    ...mapActions("PortalManage", ["selectKingKong", "changeAppKingKongLang", "changeFocusKingKongLang"]),
    closeEdit() {
      this.opType = "";
      this.showEdit = false;
      this.editInfo = {
        createTime: "",
        deleted: false,
        display: false,
        iconDay: "",
        iconNight: "",
        id: 0,
        isHot: false,
        isNew: false,
        link: "",
        name: "",
        sortNum: "",
        categoryId: "",
        updateTime: "",
        languageCode: this.editInfo.languageCode
      };
    },
    deleteRecord(id) {
      api.kingKongDelete({ id: id }).then(() => {
        this.$message.success("删除成功");
        this.selectKingKong({ type: this.areaType, languageCode: this.editInfo.languageCode });
      });
    },
    submitRecord() {
      this.$refs["kingKongForm"].validate((valid) => {
        if (valid) {
          if (this.opType === "insert") {
            this.editInfo.type = this.areaType;
            api.kingKongCreate(this.editInfo).then(() => {
              this.$message.success("新增成功");
              this.selectKingKong({ type: this.areaType, languageCode: this.editInfo.languageCode });
              this.closeEdit();
            });
          }
          if (this.opType === "update") {
            api.kingKongUpdate(this.editInfo).then(() => {
              this.$message.success("修改成功");
              this.selectKingKong({ type: this.areaType, languageCode: this.editInfo.languageCode });
              this.closeEdit();
            });
          }
        }
      });
    },
    updateOpen(info) {
      this.editInfo = JSON.parse(JSON.stringify(info));
      this.opType = "update";
      this.showEdit = true;
    },
    langChange(val) {
        this.selectKingKong({ type: this.areaType, languageCode: val });
        if(this.areaType == 1) {
            this.changeAppKingKongLang(val);
        } else if(this.areaType == 2) {
            this.changeFocusKingKongLang(val);
        }
    },

    getCategorys() {
      api.getCategorys().then(response => {
        this.categorys = response.data;
      }) 
    }

  },

  created() {
    this.getCategorys();
  }
};
</script>

<style scoped>
</style>
